import { render, staticRenderFns } from "./deviceInfo.vue?vue&type=template&id=f50a06c6&"
import script from "./deviceInfo.vue?vue&type=script&lang=js&"
export * from "./deviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports